import React from 'react';
import LegalLayout from './LegalLayout';
import { COMPANY } from '../../config/company';

function Section({ title, children }) {
  return (
    <section>
      <h2 className="text-lg font-bold text-foreground mb-3 flex items-center gap-2">
        <span className="w-1.5 h-5 rounded-full bg-primary inline-block flex-shrink-0" />
        {title}
      </h2>
      <div className="pl-4 space-y-2 text-sm">{children}</div>
    </section>
  );
}

export default function Confidentialite({ onOpenWizard }) {
  return (
    <LegalLayout title="Politique de Confidentialité" onOpenWizard={onOpenWizard}>

      <p className="text-sm bg-primary/10 border border-primary/20 rounded-xl px-4 py-3">
        Conformément au Règlement Général sur la Protection des Données (RGPD — UE 2016/679)
        et à la loi Informatique et Libertés, {COMPANY.legalName} s'engage à protéger
        les données personnelles de ses utilisateurs.
      </p>

      <Section title="Responsable du traitement">
        <p><strong className="text-foreground">{COMPANY.legalName}</strong></p>
        <p>{COMPANY.address.full}</p>
        <p>
          DPO / Contact RGPD :{' '}
          <a href={COMPANY.emailHref} className="text-primary hover:underline">{COMPANY.email}</a>
        </p>
      </Section>

      <Section title="Données collectées et finalités">
        <div className="space-y-3">
          <div className="bg-card/40 rounded-lg p-3 border border-border/30">
            <p className="font-semibold text-foreground text-xs uppercase tracking-wider mb-1">Formulaire de diagnostic</p>
            <p>Données : réponses au questionnaire, adresse e-mail (optionnelle pour le rapport PDF)</p>
            <p>Finalité : génération du rapport personnalisé, suivi commercial</p>
            <p>Base légale : intérêt légitime / exécution d'un contrat</p>
          </div>
          <div className="bg-card/40 rounded-lg p-3 border border-border/30">
            <p className="font-semibold text-foreground text-xs uppercase tracking-wider mb-1">Formulaire de contact</p>
            <p>Données : nom, e-mail, téléphone, entreprise, message</p>
            <p>Finalité : réponse à votre demande, gestion de la relation commerciale</p>
            <p>Base légale : intérêt légitime / consentement</p>
          </div>
          <div className="bg-card/40 rounded-lg p-3 border border-border/30">
            <p className="font-semibold text-foreground text-xs uppercase tracking-wider mb-1">Chat IA</p>
            <p>Données : messages échangés (anonymisés)</p>
            <p>Finalité : assistance technique, amélioration du service</p>
            <p>Base légale : intérêt légitime</p>
          </div>
        </div>
      </Section>

      <Section title="Durée de conservation">
        <p>Données prospects : <strong className="text-foreground">3 ans</strong> à compter du dernier contact</p>
        <p>Données clients : <strong className="text-foreground">5 ans</strong> après la fin de la relation contractuelle</p>
        <p>Logs serveur : <strong className="text-foreground">12 mois</strong></p>
        <p>Données de chat : <strong className="text-foreground">6 mois</strong> (anonymisées après 30 jours)</p>
      </Section>

      <Section title="Destinataires des données">
        <p>Vos données ne sont ni vendues ni louées à des tiers. Elles peuvent être transmises à :</p>
        <ul className="list-disc pl-5 space-y-1 mt-2">
          <li>Nos sous-traitants techniques (hébergeur Azure, service e-mail)</li>
          <li>Autorités compétentes sur réquisition judiciaire</li>
        </ul>
        <p className="mt-2">
          Tous nos sous-traitants sont soumis à des engagements contractuels conformes au RGPD.
        </p>
      </Section>

      <Section title="Transferts hors UE">
        <p>
          Certaines données peuvent être traitées hors de l'Union Européenne (services cloud Microsoft Azure).
          Ces transferts sont encadrés par des clauses contractuelles types approuvées par la Commission Européenne.
        </p>
      </Section>

      <Section title="Vos droits">
        <p>Conformément au RGPD, vous disposez des droits suivants :</p>
        <ul className="list-disc pl-5 space-y-1 mt-2">
          <li><strong className="text-foreground">Droit d'accès</strong> — obtenir une copie de vos données</li>
          <li><strong className="text-foreground">Droit de rectification</strong> — corriger des données inexactes</li>
          <li><strong className="text-foreground">Droit à l'effacement</strong> — "droit à l'oubli"</li>
          <li><strong className="text-foreground">Droit d'opposition</strong> — s'opposer à un traitement</li>
          <li><strong className="text-foreground">Droit à la portabilité</strong> — récupérer vos données dans un format structuré</li>
          <li><strong className="text-foreground">Droit de limitation</strong> — limiter le traitement de vos données</li>
        </ul>
        <p className="mt-3">
          Pour exercer ces droits :{' '}
          <a href={COMPANY.emailHref} className="text-primary hover:underline">{COMPANY.email}</a>
          {' '}— Délai de réponse : 30 jours maximum.
        </p>
        <p className="mt-2">
          En cas de litige, vous pouvez saisir la <strong className="text-foreground">CNIL</strong> :{' '}
          <a href="https://www.cnil.fr" target="_blank" rel="noopener noreferrer"
            className="text-primary hover:underline">www.cnil.fr</a>
        </p>
      </Section>

      <Section title="Cookies">
        <p>
          Ce site utilise uniquement des cookies techniques strictement nécessaires au fonctionnement
          (session, préférences d'affichage). Aucun cookie publicitaire ou de tracking tiers n'est utilisé.
        </p>
        <p>Vous pouvez configurer votre navigateur pour refuser les cookies sans impact sur votre navigation.</p>
      </Section>

    </LegalLayout>
  );
}
